import { TooltipProvider } from "@radix-ui/react-tooltip"
import { QueryClientProvider } from "@tanstack/react-query"
import { RouterProvider } from "@tanstack/react-router"
import { observer } from "mobx-react-lite"

import { Assembling } from "@/routes/auth/RootScene.tsx"

import type { GlobalContext } from "@/lib/context.ts"
import type { AnyRouter } from "@tanstack/react-router"
import type { IObservableValue } from "mobx"

export type AppProps = {
  globalContext: GlobalContext

  router: AnyRouter
  routerResolved: IObservableValue<boolean>
}

export const App = observer(({ globalContext, router, routerResolved }: AppProps) => {
  return (
    <>
      <TooltipProvider delayDuration={200}>
        <QueryClientProvider client={globalContext.queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </TooltipProvider>

      {!routerResolved.get() && <Assembling />}
    </>
  )
})
